/*
  rg-size-prices.js — Grove
  Shows the price delta of each Width/Depth option relative to the currently
  selected variant, e.g. "220cm (+£45)". Recomputes on every variant change
  (Dawn re-renders the variant-selects element, so we re-decorate on the
  variantChange pub/sub event). Data comes from the JSON embedded by
  main-product.liquid ([data-rg-variant-prices]).
*/
(function () {
  function init() {
    var dataEl = document.querySelector('[data-rg-variant-prices]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var names = data.options;
    var variants = data.variants;
    var symbol = dataEl.getAttribute('data-currency-symbol') || '£';
    var total = parseInt(dataEl.getAttribute('data-rg-total') || '0', 10) || variants.length;
    var baseUrl = dataEl.getAttribute('data-rg-url') || window.location.pathname;

    function priceOf(vals) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < names.length; j++) {
          if (String(v[j]) !== String(vals[j])) { ok = false; break; }
        }
        if (ok) return v[names.length];
      }
      return null;
    }

    function fmt(cents) {
      var p = Math.abs(cents) / 100;
      return p % 1 === 0 ? p.toFixed(0) : p.toFixed(2);
    }

    function currentValues(scope) {
      return names.map(function (n) {
        var sel = scope.querySelector('select[name="options[' + n + ']"]');
        if (sel) return sel.value;
        var checked = scope.querySelector('input[type="radio"][name^="' + n + '-"]:checked');
        return checked ? checked.value : null;
      });
    }

    function decorate() {
      document.querySelectorAll('variant-selects').forEach(function (scope) {
        var cur = currentValues(scope);
        if (cur.indexOf(null) !== -1) return;
        var curPrice = priceOf(cur);
        if (curPrice == null) return;
        names.forEach(function (n, idx) {
          var sel = scope.querySelector('select[name="options[' + n + ']"]');
          if (!sel) return;
          Array.prototype.forEach.call(sel.options, function (opt) {
            if (!opt.dataset.rgBase) opt.dataset.rgBase = (opt.textContent || '').trim() || opt.value;
            var vals = cur.slice();
            vals[idx] = opt.value;
            var p = priceOf(vals);
            if (p == null || opt.value === cur[idx] || p === curPrice) {
              opt.textContent = opt.dataset.rgBase;
              return;
            }
            var d = p - curPrice;
            opt.textContent = opt.dataset.rgBase + '  (' + (d > 0 ? '+' : '−') + symbol + fmt(d) + ')';
          });
        });
      });
    }

    decorate();

    /* Liquid caps product.variants at 250 unpaginated, so for high-variant
       products the inline JSON only holds the first 250. Fetch the missing
       tail pages (50 per page) from the rg-variant-prices-data section via
       the Section Rendering API and merge, then re-decorate. */
    if (variants.length < total && window.fetch && window.DOMParser) {
      var PAGE = 50;
      var seen = {};
      variants.forEach(function (v) { seen[v.slice(0, names.length).join('')] = true; });
      var pending = [];
      for (var pg = Math.floor(variants.length / PAGE) + 1; pg <= Math.ceil(total / PAGE); pg++) {
        pending.push(
          fetch(baseUrl + '?section_id=rg-variant-prices-data&page=' + pg)
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              if (!html) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var el = doc.querySelector('[data-rg-variant-prices-page]');
              if (!el) return;
              var more;
              try { more = JSON.parse(el.textContent); } catch (e) { return; }
              (more.variants || []).forEach(function (v) {
                var k = v.slice(0, names.length).join('');
                if (!seen[k]) { seen[k] = true; variants.push(v); }
              });
            })
            .catch(function () {})
        );
      }
      Promise.all(pending).then(function () { decorate(); });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(decorate, 0); });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) setTimeout(decorate, 60);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
